import React, { Fragment } from "react";
import Switch from "../switch/Switch";
import Button from "../button/Button";
import PropTypes from "prop-types";
import { useTranslate } from "../../translate";
import classNames from "classnames";

function BaseMapHeader(props) {
    const {
        inItinerary,
        children,
        showReCenter,
        reCenter,
        zoomIn,
        zoomOut,
        isAutoFollowActive,
        toggleIsAutoFollowActive,
        showAutoFollow,
        isSecondaryLayout,
        isTertiaryLayout,
        isQuaternaryLayout,
    } = props;
    const translate = useTranslate();
    const MapControlsContainer = showAutoFollow ? "div" : Fragment;
    const mapControlsContainerProps = showAutoFollow ? { className: "is-flex" } : {};
    let mapControls;
    if (isTertiaryLayout) {
        mapControls = (
            <div className="trpr__map-header-controls trpr__btn-group">
                {(children || showReCenter) && (
                    <Button size="30" icon="re-center-bold" type="icon" onClick={reCenter} tooltip="Re-center" />
                )}
                <Button size="30" type="icon" icon="minus-bold" onClickButton={zoomOut} tooltip="Zoom out" />
                <Button size="30" type="icon" icon="plus-bold" onClickButton={zoomIn} tooltip="Zoom in" />
            </div>
        );
    } else if (isQuaternaryLayout) {
        mapControls = (
            <div className="trpr__map-header-controls trpr__btn-group vertical">
                <Button
                    size="30"
                    type="icon"
                    icon="plus-bold"
                    onClickButton={zoomIn}
                    tooltip="Zoom in"
                    tooltipClasses="is-center-left"
                />
                <Button
                    size="30"
                    type="icon"
                    icon="minus-bold"
                    onClickButton={zoomOut}
                    tooltip="Zoom out"
                    tooltipClasses="is-center-left"
                />
                {(children || showReCenter) && (
                    <Button
                        size="30"
                        icon="re-center-bold"
                        type="icon"
                        onClick={reCenter}
                        tooltip="Re-center"
                        tooltipClasses="is-center-left"
                    />
                )}
            </div>
        );
    } else {
        mapControls = (
            <MapControlsContainer {...mapControlsContainerProps}>
                {(children || showReCenter) && (
                    <Button
                        className="trpr__map-header-re-center trpr__btn-reset-map"
                        size="sm"
                        mobileSize={isSecondaryLayout ? "30" : "xxsm"}
                        tabletSize={isSecondaryLayout ? "30" : "sm"}
                        icon="re-center"
                        type={isSecondaryLayout ? "icon" : null}
                        onClick={reCenter}
                        text={isSecondaryLayout ? null : translate("Re-center")}
                    />
                )}
                <div className="trpr__map-header-zoom-buttons">
                    <Button
                        className="trpr__map-header-zoom-out"
                        style={isSecondaryLayout ? {} : { marginLeft: 15, marginRight: 4 }}
                        size="24"
                        mobileSize={isSecondaryLayout ? "30" : null}
                        tabletSize={isSecondaryLayout ? "30" : "36"}
                        desktopSize="36"
                        type="icon"
                        icon="minus"
                        onClickButton={zoomOut}
                    />
                    <Button
                        className="trpr__map-header-zoom-in"
                        size="24"
                        mobileSize={isSecondaryLayout ? "30" : null}
                        tabletSize={isSecondaryLayout ? "30" : "36"}
                        desktopSize="36"
                        type="icon"
                        onClickButton={zoomIn}
                        icon="plus"
                    />
                </div>
            </MapControlsContainer>
        );
    }

    return (
        <div
            className={classNames("trpr__map-header", {
                "trpr__map-header--secondary-layout": isSecondaryLayout,
                "trpr__map-header--quaternary-layout": isQuaternaryLayout,
                "trpr__map-header--in-itinerary": inItinerary,
            })}
        >
            {showAutoFollow && (
                <Switch
                    className={`trpr__map-header-autofollow-switch ${!inItinerary ? "with-breakpoint" : ""}`}
                    id="autoFollow"
                    checked={isAutoFollowActive}
                    onChange={toggleIsAutoFollowActive}
                    label={translate("Auto-follow")}
                />
            )}
            {mapControls}
        </div>
    );
}

BaseMapHeader.defaultProps = {
    isSecondaryLayout: false,
    showAutoFollow: true,
    showReCenter: true,
    reCenter: () => {},
    zoomIn: () => {},
    zoomOut: () => {},
    isAutoFollowActive: false,
    toggleIsAutoFollowActive: () => {},
};

BaseMapHeader.propTypes = {
    reCenter: PropTypes.func,
    zoomIn: PropTypes.func.isRequired,
    zoomOut: PropTypes.func.isRequired,
    isAutoFollowActive: PropTypes.bool.isRequired,
    toggleIsAutoFollowActive: PropTypes.func.isRequired,
};

export default BaseMapHeader;
